import { request } from "@/utils/request";
import { BASE_URL } from "@/constants/config";

export const FILES_ENDPOINTS = {
  upload: `${BASE_URL}api/files/upload/`,
  download: `${BASE_URL}api/files/download/`,
  delete: `${BASE_URL}api/files/delete/`,
};

class Files {
  async removeFile(query) {
    const { data } = await request({
      url: FILES_ENDPOINTS.delete,
      method: "DELETE",
      query,
    });
    return data;
  }
}

export const FilesService = new Files();
